module.exports = __webpack_public_path__ + "static/fonts/hiragino-kaku-gothic-pron-w3.38f8503.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/hiragino-kaku-gothic-pron-w3.otf
// module id = jSi/
// module chunks = 41